import { useLocation } from 'react-router';
import { getSectionColor, type SectionColor } from '@/lib/sectionColor';

/** The brand color for the area of the app the user is currently in. */
export const useSectionColor = (): SectionColor => getSectionColor(useLocation().pathname);
